import type {AppDispatch, State} from '@/redux/typesNew';
import type {TypedUseSelectorHook} from 'react-redux';

import {composeWithDevTools} from '@redux-devtools/extension';
import {createAsyncMiddleware} from '@travel-frontend/state-handling-sdk';
import {useDispatch, useSelector} from 'react-redux';
import {applyMiddleware, legacy_createStore as createStore} from 'redux';
import thunk from 'redux-thunk';

import {googleTagManagerMiddleware} from '@/redux/middleware/googleTagManager';
import {reducer} from '@/redux/reducer';

const middlewares = applyMiddleware(
  thunk,
  createAsyncMiddleware,
  googleTagManagerMiddleware
);

export const reduxStore = createStore(
  reducer,
  import.meta.env.MODE === 'production'
    ? middlewares
    : composeWithDevTools(middlewares)
);

export const useAppSelector: TypedUseSelectorHook<State> = useSelector;
export const useAppDispatch = () => useDispatch<AppDispatch>();
